<template>
    <div id="home" class="home">
        <img class="avatar-img" :src="require('@/assets/images/profile2.png')" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
        <div data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
            <div class="name typewriter"> Dimitris Karageorgos </div>
            <div @click="goToLinkedIn">
                <svg class="linked-in" stroke="#7e7373" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>
            </div>
        </div>
        <span class="description" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300"> {{ description }} </span>
        <v-btn
            :loading="loading"
            :disabled="loading"
            class="download-button"
            v-bind="attrs"
            v-on="on"
            @click="downloadCV"
        > Download CV
            <template v-slot:loader>
                <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                </span>
            </template>
        </v-btn>
        <!-- <v-menu
            v-model="languageTooltipShow"
            transition="slide-x-transition"
            :close-on-content-click="true"
            min-width="100px"
            :nudge-bottom="2"
            :nudge-right="10"
            offset-x
        >
            <template v-slot:activator="{ on, attrs }">

            </template> -->

        <!-- <div
                class="language-tooltip"
            >
                <img class="flag-img" :src="require('@/assets/icons/english-flag.svg')" @click="languageSelect('EN')">
                <img class="flag-img" :src="require('@/assets/icons/greek-flag.svg')" @click="languageSelect('GR')">
            </div> -->
        <!-- </v-menu> -->
    </div>
</template>

<script>
    export default {
        name: 'Home',
        data: () => {
            return {
                languageTooltipShow: false,
                loading: false
            }
        },
        computed: {
            description() {
                return `I'm a software engineer with ${new Date().getFullYear() - 2019}+ years of experience, specializing primarily in backend development, but also skilled in frontend development for complex, scalable web applications and services.`
            }
        },
        watch: {
            languageTooltipShow: {
                handler(oldval, newval) {
                    if (newval) {
                        this.loading = false
                    }
                }
            }
        },
        methods: {
            goToLinkedIn() {
                window.location.href = 'https://www.linkedin.com/in/dimitris-karageorgos-296b59184'
            },
            downloadFile(file, filename) {
                fetch(file)
                    .then((resp) => resp.blob())
                    .then((blob) => {
                        const url = window.URL.createObjectURL(blob)
                        const a = document.createElement('a')
                        a.style.display = 'none'
                        a.href = url
                        a.download = filename
                        document.body.appendChild(a)
                        a.click()
                        window.URL.revokeObjectURL(url)
                    })
            },
            tooltipShow() {
                this.loading = !this.loading
            },
            languageSelect(language) {
                this.loading = !this.loading
                const fileName = `CV_Karageorgos_Dimitrios-${language}.pdf`
                this.downloadFile(require(`@/assets/pdf/${fileName}`), fileName)
            },
            downloadCV() {
                this.downloadFile(require(`@/assets/pdf/CV_Karageorgos_Dimitris.pdf`), 'CV_Karageorgos_Dimitris.pdf')
            }
        }
    }
</script>
<style scoped>
.home {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f8fc;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.typewriter {
    overflow: hidden;
    border-right: .15em solid #01aebe;
    margin: 0 auto;
    white-space: nowrap;
    animation:
    typing 3s steps(20, end),
    blink-caret .75s step-end infinite;
}

@keyframes typing {
    from { width: 0 }
    to { width: 100% }
}

@keyframes blink-caret {
    from, to { border-color: transparent }
    50% { border-color: #01aebe; }
}

.avatar-img {
    max-width: 350px;
    /* filter: grayscale(100%); */
}

.name {
    font-family: "Poppins-Bold";
    font-size: 2rem;
}

.description {
    font-family: "Poppins";
    color: #7e7373;
    font-size: 1.1em;
    padding-left: 15%;
    padding-right: 15%;
}

.linked-in:hover {
    transform: translateY(-5px);
    transition: all .3s ease;
    cursor: pointer;
    stroke: #01aebe;
}

.download-button {
    margin-top: 1.5em;
    font-family: "Poppins";
    text-decoration: none;
    color: #1a1a1a;
    font-weight: 500;
    font-size: 1.1em;
    display: inline-block;
    border: 2px solid #7e7e7e;
    padding: 8px 35px 7px;
    transition: all .3s ease;
    border-radius: 3em;
    margin-bottom: 0.5rem;
}

.language-tooltip {
    background-color: #1a1a1a;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 30px;
}

.flag-img {
    border-radius: 5px;
    width: 27px;
}

.flag-img:hover {
    cursor: pointer;
    width: 30px;
}

.download-button:hover {
    color: #fff;
    background-color: black !important;
    border-color: black;
}

.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
